import { supabase } from '../supabase'
import { ServiceError } from '../errors/service-error'

export type HostDecision = 'accept' | 'decline'

/**
 * The database is the sole authority for actor, payment, deadline and state.
 * The client never writes `rentals.status` for a paid host decision.
 */
export async function respondToPaidRental(rentalId: string, decision: HostDecision): Promise<void> {
  const { error } = await supabase.rpc('respond_to_paid_rental', {
    p_rental_id: rentalId,
    p_decision: decision,
    p_reason: decision === 'decline' ? 'host_declined_paid_booking' : undefined,
  })
  if (error) throw ServiceError.fromSupabaseError(error)
}
